import { Box, Breadcrumbs, Button, CircularProgress, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/opinionTradingSlice';
import { useDispatch, useSelector } from "react-redux";
import { AiFillCloseCircle } from 'react-icons/ai';
import { CHANGESTATUS, INPLAY, JOIN_TRADE, SUSPENDINPLAY, TRADING_CANCEL, TRADING_CHANGE_STATUS, TRADING_LIST } from "../../constant/endpoint";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MdNavigateNext } from "react-icons/md";
import Swal from "sweetalert2";
import { set } from "lodash";

export const HoldTradingMatching = ({ }) => {
    console.log("HoldTradingMatching");

    const predictionState = useSelector(state => state.opinionTrading)
    
    const { match_id, series_id, sport, pred_id } = useParams()
    const dispatch = useDispatch();
    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }
    const [currentData, setCurrentData] = useState("");
    const [loading, setLoading] = useState(false)

    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/bot-matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <Link underline="hover"
            color="inherit" to={`/matchlist/trading-bot/${match_id}/${series_id}/1`} >
            <h5>{'Trading'}</h5>
        </Link>,
        <h5>{pred_id}</h5>
    ];
    const getOpinionTrading = async () => {
        const response = await axios.get(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id))
        // setLoading(true)
        if (response?.data?.status == 'success') {
            console.log("response?.data", response?.data);
            
            setCurrentData(getPredId(response.data.data.result))
            dispatch(setEditQuestion(getPredId(response.data.data.result)));
            // setLoading(false)

        }
    }
    const getPredId = (arr) => {
        let data = {}
        data = arr.find((pre) => pre._id === pred_id)
        return data
    }

    useEffect(() => {
        getOpinionTrading()
    console.log("predictionState", predictionState.questionStates.joinSlotHold,  predictionState.questionStates.optionForHold);

    }, [])

    const holdThePrediction = async (option) => {
     
        const requestData = {
            "join_slots": predictionState.questionStates.joinSlotHold,
            "match_id": match_id,
            "option_id": option,
            "option_name": option == 1 ? "YES" : "NO",
            "prediction_id": pred_id,
            "slot_fee": 9.5,
            "sport": 1
        }
        setLoading(true)
        const response = await axios.post(JOIN_TRADE, requestData);
        setLoading(false)
            if (response) {
                Swal.fire(response?.data?.data?.message || "Something Went Wrong")
            }
      
    }


    return (
        <center>
            {loading &&
            <Box sx={{
                position: 'fixed',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999, // Ensure it stays above other elements
                paddingTop: '20%', // Space from top of the page
            }}>
                <CircularProgress></CircularProgress>
            </Box>   }
            <Box style={{ padding: "20px 80px", margin: "80px 0 0 0" }}>
                <Breadcrumbs
                    separator={<MdNavigateNext fontSize="small" />}
                    aria-label="breadcrumb"
                >

                    {breadcrumbs}
                </Breadcrumbs>

                <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>Hold the Matching</h2>
                        </Grid>
                        <Grid container justifyContent={"center"}>
                            <Grid item xs={4}>
                                <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                        </Grid>
                            <Grid item xs={4}>
                                <h4 style={{wordBreak: "break-all"}}>{`Question English : ${predictionState?.questionStates?.question_english}`}</h4>
                        </Grid>
                        
                        </Grid>
                </Grid>
                
                <hr />
                <Grid container style={{justifyContent:"start"}}>
                    <Grid xs={3} item  >
                        <label>Slots</label>
                            <TextField id="outlined-basic" type='number' size={'small'} fullWidth variant="outlined" name={'joinSlotHold'} onChange={setQuestion} value={predictionState.questionStates.joinSlotHold}  />
                    </Grid>
                    <Grid xs={3} item mt={2}>
                    <Button variant={'contained'} size={"large"} color={predictionState.questionStates.holdMatching ? 'error' : 'info'} onClick={()=>holdThePrediction(1)} disabled={loading}>YES</Button>
                    </Grid>
                    <Grid xs={3} item mt={2}>
                    <Button variant={'contained'} size={"large"} color={predictionState.questionStates.holdMatching ? 'error' : 'warning'} onClick={()=>holdThePrediction(2)} disabled={loading}>NO</Button>
                    </Grid>
                </Grid>
            




            </Box>
        </center>

    )
}